module.exports = __webpack_public_path__ + "static/media/997686.6b921eea.jpg";